import React, { useEffect, useState, useContext } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Header from "./Header";
import Body from "./Body";
import Loader from "App/common/ui/Loader";
import {
  toggleBackupPlansCheckList,
  changeBackupPlansCheckList,
  setCleanBackupPlanCache,
  editDefaultPlan
} from "store/actions";
import { LayoutContext } from "App/common/hoc/Layout";
import Empty from "../Empty";
import { scrollIntoView } from "utils";

function Table(props) {
  const { lMethods } = useContext(LayoutContext);
  const [sortCol, setSortCol] = useState({
    col: "planName",
    order: false
  });
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    if (props.editDefaultplan) {
      if (
        props.backupPlan.backupPlans.data[1]?.status !==
        props.enums.BackupPlanStatus.DISABLED
      ) {
        props.setCleanBackupPlanCache(1);
        lMethods.openSlidingPopup("backupPlan", "backupPlanSettings", {
          planID: 1
        });
      }
      props.editDefaultPlan(false);
      setTimeout(() => {
        scrollIntoView("#backup_plan_1");
      }, 1000);
    }
  }, [props.editDefaultplan]);

  const toggleSort = col => {
    if (col === sortCol.col) {
      setSortCol(prevState => {
        return { ...prevState, order: !prevState.order };
      });
    } else {
      setSortCol({
        col: col,
        order: false
      });
    }
  };

  const headerCheckBox = () => {
    if (!props.backupPlan.backupPlans.loading) {
      const getAllPlanIds = filteredData.map(plan => plan.planId);
      if (props.backupPlan.backupPlans.checkList.length === 0) {
        props.changeBackupPlansCheckList(getAllPlanIds);
      } else {
        props.changeBackupPlansCheckList([]);
      }
    }
  };

  return (
    <div className="tabular_data_wrap listview_sec">
      <Header
        headerCheckBox={headerCheckBox}
        checked={
          props.backupPlan.backupPlans.checkList
            ? props.backupPlan.backupPlans.checkList.length !== 0
            : false
        }
        semiChecked={
          props.backupPlan.backupPlans.checkList
            ? props.backupPlan.backupPlans.checkList.length !==
              filteredData.length
            : false
        }
        checkList={props.backupPlan.backupPlans.checkList}
        toggleSort={toggleSort}
        sortCol={sortCol}
      />

      <div className="table_content_body">
        {!props.backupPlan.backupPlans.loading &&
        props.enums &&
        props.enums.ScheduleType ? (
          <Body
            sortCol={sortCol}
            search={props.search}
            getTotalMachines={props.getTotalMachines}
            totalMachines={props.totalMachines}
            setFilteredData={setFilteredData}
          />
        ) : (
          <Loader />
        )}
        {}
        {props.totalMachines === 0 &&
          !props.backupPlan.backupPlans.loading &&
          props.search !== "" && <Empty />}
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    backupPlan: state.backupPlan,
    enums: state.common.enums,
    editDefaultplan: state.backupPlan.editDefaultplan
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleBackupPlansCheckList,
      changeBackupPlansCheckList,
      setCleanBackupPlanCache,
      editDefaultPlan
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Table);
